export function getCurrentEnvironment() {
  try {
    const env = process.env.ENVIRONMENT
    if (!env) {
      const runtimeConfig = useRuntimeConfig()
      return runtimeConfig.public.environment
    }

    return env
  }
  catch {
    return 'production'
  }
}
